import React from 'react';
import { getAlternativeContactTypeMeta } from '../pages/invalid-details/subparts/invalidDetailsQuery';
import './AlternativeContactsDisplay.css';

function AlternativeContactsDisplay({ contacts, emptyLabel = '—' }) {
    if (!contacts?.length) {
        return <span className="ecx-alternative-contacts__empty">{emptyLabel}</span>;
    }

    return (
        <div className="ecx-alternative-contacts">
            {contacts.map((contact, index) => {
                const meta = getAlternativeContactTypeMeta(contact.type);

                return (
                    <React.Fragment key={`${contact.type}-${contact.detail}-${index}`}>
                        {index > 0 && (
                            <span className="ecx-alternative-contacts__sep" aria-hidden="true">
                                ·
                            </span>
                        )}
                        <span className="ecx-alternative-contacts__item">
                            <i className={`bi ${meta.icon}`} aria-hidden="true" />
                            <span className="ecx-alternative-contacts__label">{meta.label}:</span>
                            <span className="ecx-alternative-contacts__value">{contact.detail}</span>
                        </span>
                    </React.Fragment>
                );
            })}
        </div>
    );
}

export default AlternativeContactsDisplay;
